import get from 'lodash/get'

export default {
  all: state => state,
  single: state => ({ from, to }) => get(state, [from, to], null),
}
